// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

import { LatLng } from './LatLng';
import type { LatLngModelType } from './LatLng';

export type AddressLatLngModelType = {
    address: string,
    latLng: LatLngModelType,
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class AddressLatLng extends ImmutableModel {
    static fromJS(json: AddressLatLngModelType): AddressLatLng {
        const state: Object = Object.assign({}, json);
        state.latLng = LatLng.fromJS(state.latLng);
        return new this(Immutable.Map(state));
    }

    toJS(): AddressLatLngModelType {
        return {
            address: this.address,
            latLng: this.latLng.toJS(),
        };
    }

    get address(): string {
        return this._state.get('address');
    }

    setAddress(address: string): this {
        return this.clone(this._state.set('address', address));
    }

    get latLng(): LatLng {
        return this._state.get('latLng');
    }

    setLatLng(latLng: LatLng): this {
        return this.clone(this._state.set('latLng', latLng));
    }
}
